var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import uuid from "uuid/v4";
import http from "http";
import { TextEncoder, TextDecoder } from "text-encoding";
import StompServer from "stomp-broker-js";
import waitUntil from "../util/waitUntil";
global.TextEncoder = global.TextEncoder || TextEncoder;
global.TextDecoder = global.TextDecoder || TextDecoder;
var MockStompBroker = /** @class */ (function () {
    function MockStompBroker(_a) {
        var _b = _a === void 0 ? {} : _a, port = _b.port, portRange = _b.portRange, _c = _b.endpoint, endpoint = _c === void 0 ? "/websocket" : _c;
        this.sentMessageIds = [];
        this.queriedSessionIds = [];
        this.sessions = {};
        this.thereAreNewSessions = this.thereAreNewSessions.bind(this);
        this.registerMiddlewares = this.registerMiddlewares.bind(this);
        this.setMiddleware = this.setMiddleware.bind(this);
        this.port = port || MockStompBroker.getPort(portRange);
        this.httpServer = http.createServer();
        this.stompServer = new StompServer({
            server: this.httpServer,
            path: endpoint
        });
        this.registerMiddlewares();
        this.httpServer.listen(this.port);
    }
    MockStompBroker.getRandomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    };
    MockStompBroker.getPort = function (portRange) {
        if (portRange === void 0) { portRange = [8000, 9001]; }
        var minInclusive = portRange[0];
        var maxExclusive = portRange[1];
        var port = this.getRandomInt(minInclusive, maxExclusive);
        return this.PORTS_IN_USE.includes(port) ? this.getPort() : port;
    };
    MockStompBroker.prototype.newSessionsConnected = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newSessionsIds;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, waitUntil(this.thereAreNewSessions, "No new sessions established")];
                    case 1:
                        _a.sent();
                        newSessionsIds = Object.values(this.sessions)
                            .filter(function (_a) {
                            var sessionId = _a.sessionId;
                            return !_this.queriedSessionIds.includes(sessionId);
                        })
                            .filter(function (_a) {
                            var hasConnected = _a.hasConnected;
                            return hasConnected;
                        })
                            .map(function (_a) {
                            var sessionId = _a.sessionId;
                            return sessionId;
                        });
                        this.queriedSessionIds = this.queriedSessionIds.concat(newSessionsIds);
                        return [2 /*return*/, newSessionsIds];
                }
            });
        });
    };
    MockStompBroker.prototype.subscribed = function (sessionId) {
        var _this = this;
        return waitUntil(function () {
            var session = _this.sessions[sessionId];
            return Boolean(session && session.hasReceivedSubscription);
        }, "Session " + sessionId + " never subscribed to a topic");
    };
    MockStompBroker.prototype.scheduleMessage = function (topic, payload, headers) {
        if (headers === void 0) { headers = {
            "content-type": "application/json;charset=UTF-8"
        }; }
        var body = JSON.stringify(payload);
        var mockMessageId = uuid();
        this.stompServer.send("/" + topic, __assign(__assign({}, headers), { mockMessageId: mockMessageId }), body);
        return mockMessageId;
    };
    MockStompBroker.prototype.messageSent = function (messageId) {
        var _this = this;
        return waitUntil(function () { return _this.sentMessageIds.includes(messageId); }, "Message " + messageId + " was never sent");
    };
    MockStompBroker.prototype.disconnected = function (sessionId) {
        var _this = this;
        return waitUntil(function () {
            var session = _this.sessions[sessionId];
            return Boolean(session && session.hasDisconnected);
        }, "Session " + sessionId + " never disconnected");
    };
    MockStompBroker.prototype.kill = function () {
        this.httpServer.close();
    };
    MockStompBroker.prototype.getPort = function () {
        return this.port;
    };
    MockStompBroker.prototype.thereAreNewSessions = function () {
        var numberOfSessions = Object.entries(this.sessions).length;
        var numberOfSessionsQueried = this.queriedSessionIds.length;
        return numberOfSessions - numberOfSessionsQueried > 0;
    };
    MockStompBroker.prototype.setMiddleware = function (_a) {
        var event = _a[0], middlewareHook = _a[1];
        this.stompServer.setMiddleware(event, function (socket, args, next) {
            process.nextTick(function () {
                return middlewareHook({ sessionId: socket.sessionId, frame: args.frame });
            });
            return next();
        });
    };
    MockStompBroker.prototype.registerMiddlewares = function () {
        var _this = this;
        var strategies = [
            [
                "connect",
                function (_a) {
                    var sessionId = _a.sessionId;
                    return (_this.sessions[sessionId] = __assign(__assign({}, MockStompBroker.BASE_SESSION), { sessionId: sessionId, hasConnected: true }));
                }
            ],
            [
                "subscribe",
                function (_a) {
                    var sessionId = _a.sessionId;
                    return (_this.sessions[sessionId].hasReceivedSubscription = true);
                }
            ],
            [
                "send",
                function (_a) {
                    var frame = _a.frame;
                    return _this.sentMessageIds.push(frame.headers.mockMessageId);
                }
            ],
            [
                "disconnect",
                function (_a) {
                    var sessionId = _a.sessionId;
                    return (_this.sessions[sessionId].hasDisconnected = true);
                }
            ]
        ];
        strategies.forEach(this.setMiddleware);
    };
    MockStompBroker.PORTS_IN_USE = [];
    MockStompBroker.BASE_SESSION = {
        hasConnected: false,
        hasReceivedSubscription: false,
        hasSentMessage: false,
        hasDisconnected: false
    };
    return MockStompBroker;
}());
export default MockStompBroker;
